export default __webpack_public_path__ + "static/media/DSC06083.bd2a1763.jpg";